export default {
	api_url: (process.env.NODE_ENV === 'production') ? location.protocol + '//codmanagementapi.xbees.in/api/' : location.protocol + '//codstageapi.xbees.in/api/',
	// api_url: "http://localhost:4500/api/",
	iptracker_url: (process.env.NODE_ENV === 'production') ? location.protocol + '//track.xbees.in/api/UserTracker' : location.protocol + '//stageiptracking.xbees.in/api/UserTracker',
	forgotpwd_url: (process.env.NODE_ENV === 'production') ? location.protocol + '//userauthentication.xbees.in/#/forgotpassword' : location.protocol + '//stageusermanagement.xbees.in/#/forgotpassword',
	authclientidapi: 'live-codportal-service',
	authclientidui: 'live-codportal-ui',
	keycloakUrl: 'https://auth.xbees.in',
	app_url: 'https://codmanagement.xbees.in',
	isKavachLogin: true
}


// WEBPACK FOOTER //
// ./src/constants.js